import ToolButton from "./toolButton";

// panTool

export default class PanTool extends ToolButton {
  deactivateTool() {
    // console.log("PanTool deactivateTool")
  }

  activateTool(event: any) {
    // console.log("panTool start", this.view)
    try {
      // Disable other tools
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      // Change mouse cursor
      document.body.style.cursor = "default";
    } catch (error) {
      console.error("Error: in panTool " + +error.message);
    }
  }
}
